export default __webpack_public_path__ + "static/media/m5.76aa97e8.png";